<template>
    <div class="my-4 d-stepper w-8/12 mx-auto flex items-start justify-center">
        <div
            v-for="(stepItem, index) in steps"
            :key="index"
            class="flex items-start justify-center flex-col md:flex-row"
        >
            <div class="flex flex-col items-center w-28">
                <step-viewer
                    :index="index"
                    :step="step"
                    :info="stepItem"
                    @click="onClick"
                />
            </div>

            <div
                v-if="index < steps.length - 1"
                class="hidden mt-2 bg-theme-disabled lg:flex items-center text-center rounded-lg py-1 px-1 h-2 w-20"
            >
                <div
                    v-show="step > index"
                    class="w-full text-white text-sm inline-block bg-theme-success px-1 rounded-lg h-1"
                ></div>
            </div>
        </div>
    </div>
</template>

<script>
import StepViewer from "./StepViewer.vue";

export default {
    name: "StepsViewer",
    components: { StepViewer },
    props: {
        steps: {
            type: Array,
            default: () => [],
            required: true
        },
        step: {
            type: Number,
            default: () => 0,
            required: true
        }
    },
    emit: ["click"],
    methods: {
        onClick(index) {
            this.$emit("click", index);
        }
    }
};
</script>
